import React from 'react';

function Header() {
    return (<header>Level 500 Sample Solution - React</header>);
}

export default Header;